import React from "react";

function IconInformeAuditoria() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      x="0"
      y="0"
      version="1.1"
      viewBox="0 0 16 16"
      xmlSpace="preserve"
    >
      <path
        fill="#0D6EFD"
        d="M9.021 12.88l-.369.968 1.113-.242-.744-.726zm3.666-3.849l-3.154 3.043 1.109 1.082 3.174-3.033-1.129-1.092zm0-1.096c.13 0 .256.048.358.145l1.878 1.814.015.231a.529.529 0 01-.157.37l-4.019 3.839-.146.042-2.523.549a.507.507 0 01-.502-.168l-.18-.211.093-.306.904-2.371.086-.088L12.33 8.08a.513.513 0 01.357-.145zM7.936 1.594v1.689h1.688L7.936 1.594zM.934 0h6.729l3.541 3.541v4.861h-.934V4.216H7.002V.934H.934v13.07h5.602v.934H.934A.934.934 0 010 14.004V.934C0 .418.418 0 .934 0z"
      ></path>
      <path
        fill="#0A58CA"
        d="M5.971 4.507c0 .229-.043.385-.131.467-.087.082-.247.124-.479.124-.23 0-.387-.04-.471-.121-.085-.08-.128-.233-.128-.459 0-.23.043-.386.131-.468.087-.082.247-.124.48-.124.23 0 .387.04.471.121.084.08.127.233.127.46zm-.113 7.134c0 .032-.007.06-.023.08a.183.183 0 01-.078.058.614.614 0 01-.148.036 1.998 1.998 0 01-.243.012c-.095 0-.173-.004-.237-.012a.714.714 0 01-.151-.036c-.038-.016-.063-.034-.077-.058a.142.142 0 01-.021-.08V6.307c0-.028.006-.053.021-.078a.168.168 0 01.077-.058.543.543 0 01.151-.035c.063-.008.142-.011.237-.011.099 0 .179.003.243.012.064.008.113.018.148.034s.061.036.078.06c.017.025.023.05.023.078v5.332z"
      ></path>
    </svg>
  );
}

export default IconInformeAuditoria;
